module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraBold.c24d12f.woff";